import React, { useState } from "react";
import { Menus } from "../../../components/Menus";
import { LuHardDrive } from "react-icons/lu";
import { FaUsers, FaCreditCard } from "react-icons/fa";
import { MdOutlinePayment } from "react-icons/md";
import Genral from "./AccoundSettings/Genral";
import PricingPage from "./AccoundSettings/PricingPage";
import Billing from "./AccoundSettings/Billing";

const options = [
  {
    key: "general",
    label: "General",
    icon: <LuHardDrive size={24} />,
  },
  {
    key: "plans",
    label: "Plans",
    icon: <FaUsers size={24} />,
  },
  {
    key: "billing",
    label: "Billing",
    icon: <MdOutlinePayment size={24} />,
  },
];

const AccoundSettings = ({ activeOption, setActiveOption }) => {
  return (
    <div className="flex flex-1 gap-4 flex-col relative p-6 py-4">
      <h1 className="text-2xl font-semibold text-gray-600 my-3">Settings</h1>
      <div className="flex gap-3 sm:gap-5 md:gap-10 flex-col md:flex-row">
        <Menus
          options={options}
          setActiveOption={setActiveOption}
          activeOption={activeOption}
        />
        <div className="flex-1">
          {activeOption === "general" && <Genral />}
          {activeOption === "plans" && <PricingPage />}
          {activeOption === "billing" && (
            <Billing setActiveOption={setActiveOption} />
          )}
        </div>
      </div>
    </div>
  );
};

export default AccoundSettings;
